module.exports = __webpack_public_path__ + "static/media/void-bg.f5b7efc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/void-bg.jpg
// module id = 424
// module chunks = 0